import React from 'react';
import type { TypeListTableProps } from '../types';

const renderSortIcon = (active: boolean, direction: 'asc' | 'desc') => {
  if (!active) {
    return <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.3 }}><path d="M6 9l6 6l6 -6" /></svg>;
  }

  return direction === 'asc'
    ? <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 15l6 -6l6 6" /></svg>
    : <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6l6 -6" /></svg>;
};

const TypeListTable = ({
  types,
  sortField,
  sortDir,
  onSort,
  canManage,
  onEdit,
  onDelete,
  loadingMore,
  tableRef,
  sentinelRef,
  endMessage,
  t,
}: TypeListTableProps) => {
  return (
    <>
      <div className="table-responsive" ref={tableRef} style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <table className="table table-vcenter card-table app-table mb-0">
          <thead style={{ position: 'sticky', top: 0, background: 'var(--tblr-bg-surface, #fff)', zIndex: 10 }}>
            <tr>
              <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => onSort('name')}>
                {t('warehouses.types.name')} {renderSortIcon(sortField === 'name', sortDir)}
              </th>
              <th style={{ width: '80px' }}>{t('warehouses.types.color')}</th>
              <th>{t('warehouses.types.description')}</th>
              <th className="w-1">{t('common.actions')}</th>
            </tr>
          </thead>
          <tbody>
            {types.map((type) => (
              <tr key={type.id}>
                <td>{type.name}</td>
                <td>
                  <div
                    className="color-swatch"
                    style={{
                      width: '40px',
                      height: '24px',
                      backgroundColor: type.color || '#cccccc',
                      borderRadius: '4px',
                      border: '1px solid rgba(0,0,0,0.1)',
                    }}
                    title={type.color || undefined}
                  ></div>
                </td>
                <td className="text-muted">{type.description || '-'}</td>
                <td>
                  <div className="btn-group">
                    {canManage && (
                      <>
                        <button className="btn btn-sm btn-outline-info" onClick={() => onEdit(type)} title={t('common.edit')}>
                          <i className="ti ti-edit"></i>
                        </button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => onDelete(type.id)} title={t('common.delete')}>
                          <i className="ti ti-trash"></i>
                        </button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
            <tr ref={sentinelRef} style={{ height: '1px' }}>
              <td colSpan={4} style={{ padding: 0 }}></td>
            </tr>
            {loadingMore && (
              <tr>
                <td colSpan={4} className="text-center py-3 text-muted">
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {t('common.loading')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {endMessage && <div className="text-center py-2 border-top"><small className="text-muted">{endMessage}</small></div>}
    </>
  );
};

export default TypeListTable;
